import React, { useState } from 'react';
import Modal from '../ui/Modal';

/** Mount the AI workflow only after permission; closing resets permission. */
export default function AiProcessingConsent({ isOpen, onClose, children }: { isOpen: boolean; onClose: () => void; children: React.ReactNode }) {
  if (!isOpen) return null;
  return <ConsentSession onClose={onClose}>{children}</ConsentSession>;
}
function ConsentSession({ onClose, children }: { onClose: () => void; children: React.ReactNode }) {
  const [allowed, setAllowed] = useState(false);
  if (allowed) return <>{children}</>;
  return <Modal isOpen onClose={onClose} title="Allow AI processing?">
    <div className="space-y-4 p-4 text-zinc-300">
      <p>This optional feature sends your instructions, imported text, and relevant build and modification details to OpenAI to suggest changes. Imported documents may contain personal information; remove it before continuing.</p>
      <p>You review suggestions before saving. You can edit your build manually without AI.</p>
      <div className="flex flex-wrap gap-3">
        <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
        <button type="button" className="btn-primary" onClick={() => setAllowed(true)}>Allow and continue</button>
      </div>
    </div>
  </Modal>;
}
